import { Advisor } from "@antv/ava";
import React from "react";
import { Select } from "antd";
import { DataFrame } from "@antv/ava";
import ReactECharts from "echarts-for-react";
import { generateEchartAdvices } from "@src/util/intelligence-search/chart-advisor";

const AutoGeneratedChart: React.FC<{ data?: Record<string, any>[] }> = ({ data }) => {
    const [chartSpecIdx, setChartSpecIdx] = React.useState<number>(0);

    const fieldInfo = React.useMemo(() => {
        const df = new DataFrame(data);
        return df.info();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(data)]);

    const advises = React.useMemo(() => {
        if (data === undefined) {
            return null;
        }
        // return convertAdviseT?oEchartOptions()

        const advisor = new Advisor();
        const avaAdvices = advisor.advise({ data });

        return generateEchartAdvices({ avaAdvices: avaAdvices, df_info: fieldInfo });

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(data)]);

    if (data === undefined) {
        return <>Missing</>;
    }

    console.log(fieldInfo);
    console.log(advises);

    if (advises === null || advises.length === 0) {
        return <>TODO: Some message describe chart can not be generated because of data complexity </>;
    }

    return (
        <div>
            <div className="flex justify-start">
                <Select value={chartSpecIdx} onChange={setChartSpecIdx} className="w-[200px]">
                    {advises.map(({ name }, idx) => {
                        return <Select.Option value={idx}>{name}</Select.Option>;
                    })}
                </Select>
            </div>
            <div className="h-[700px] m-8">
                <ReactECharts key={chartSpecIdx} option={advises[chartSpecIdx].options} style={{ height: "100%" }} />
            </div>
        </div>
    );
};

// export const AutoGeneratedChartMemo = React.memo(AutoGeneratedChart);
export const AutoGeneratedChartMemo = AutoGeneratedChart;
